import { Physician } from "#/decision_tree_viewer/models/physician";
import { BaseDecisionTreeViewerApi } from "./base";

class PhysicianApi extends BaseDecisionTreeViewerApi {
  constructor() {
    super({ model: Physician, baseURL: "/physicians" });
  }

  /**
   * Search for Physicians by a given search term.
   *
   * @param {String} q - the search term
   * @returns {Array<Physician>} - An array of Physicians
   */
  async search(q) {
    return this.get("", { q });
  }
}

let api;

export const createPhysicianApi = () => {
  api ??= new PhysicianApi();

  return {
    search: async (query) => api.search(query),
    find: async (id) => api.get(id.toString()),
  };
};
